import React from 'react'

const Background = () => {
    return (
        <div className="background2"></div>
    )
}

export default Background
